export enum SortType {
    Alphabetical = 1,
    ReversedAlphabetical = 2,
    Chronological = 3,
    ReversedChronological = 4,
}
